import React from 'react';
import { Navigate } from 'react-router-dom';

const AuthGuard = ({ children }) => {
    const token = localStorage.getItem('token');

    // If token is not found, redirect to sign-in page
    if (!token) {
        return <Navigate to="/auth/sign-in" />;
    }

    // If token exists, render the children (protected content)
    return children;
};

export default AuthGuard;
